module.exports = __webpack_public_path__ + "static/img/31.bcae5713.gif";